/* Counterpoint restyle: click to load video modal.
   Nothing is fetched until the user clicks a thumbnail. Header scroll state is
   handled by the theme's own header.js plus CSS, so there is no scroll listener here. */
(function () {
  'use strict';

  function closeModal(dialog) {
    var video = dialog.querySelector('video');
    if (video) {
      video.pause();
      video.removeAttribute('src');
      while (video.firstChild) video.removeChild(video.firstChild);
      video.load();
    }
    if (dialog.open) dialog.close();
  }

  function openModal(trigger) {
    var id = trigger.getAttribute('data-modal');
    var dialog = document.getElementById(id);
    if (!dialog) return;

    var src = trigger.getAttribute('data-video-src');
    var label = trigger.getAttribute('data-video-title') || '';
    if (!src) return;

    var video = dialog.querySelector('video');
    if (video) {
      var source = document.createElement('source');
      source.setAttribute('src', src);
      source.setAttribute('type', 'video/mp4');
      video.appendChild(source);
      video.setAttribute('aria-label', label);
      video.load();
    }

    dialog.__cpReturnFocus = trigger;

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    if (video) {
      var play = video.play();
      if (play && play.catch) play.catch(function () { /* user can press play */ });
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest('[data-cp-video]') : null;
    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    var closer = event.target.closest ? event.target.closest('[data-cp-video-close]') : null;
    if (closer) {
      event.preventDefault();
      var dialog = closer.closest('dialog');
      if (dialog) closeModal(dialog);
    }
  });

  /* click the backdrop to dismiss */
  document.addEventListener('click', function (event) {
    if (event.target && event.target.tagName === 'DIALOG' && event.target.classList.contains('cp-modal')) {
      closeModal(event.target);
    }
  });

  /* Motion rule: the hero is the only thing that moves on its own.
     The stock product gallery ships product-media videos with autoplay+loop.
     Strip that so they rest on their poster and play only when asked.
     Product data is untouched; this is presentation only. */
  function calmAutoplay() {
    var vids = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (v.closest('.cp-modal') || v.closest('.cp-hero') || v.hasAttribute('data-cp-lead')) continue;
      v.removeAttribute('autoplay');
      v.removeAttribute('loop');
      v.setAttribute('preload', 'none');
      if (!v.hasAttribute('controls')) v.setAttribute('controls', 'controls');
      try { v.pause(); } catch (e) { /* not ready yet */ }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', calmAutoplay);
  } else {
    calmAutoplay();
  }
  /* galleries re-render after their slider boots */
  window.addEventListener('load', function () { setTimeout(calmAutoplay, 400); });

  /* ---- review cards: play only what is on screen, load nothing until then ---- */
  var STAR = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.6l2.47 5.3 5.53.66-4.08 3.9 1.08 5.64L10 14.4l-5 2.7 1.08-5.64L2 7.56l5.53-.66z"/></svg>';

  function initInViewVideo() {
    var vids = document.querySelectorAll('video[data-cp-inview]');
    if (!vids.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < vids.length; i++) { attach(vids[i]); }
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          attach(v);
          var p = v.play();
          if (p && p.then) {
            p.then(function () { v.classList.add('is-playing'); }).catch(function () {});
          } else {
            v.classList.add('is-playing');
          }
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '15% 0px', threshold: 0.25 });

    for (var j = 0; j < vids.length; j++) { io.observe(vids[j]); }
  }

  function attach(v) {
    if (v.dataset.cpLoaded) return;
    var src = v.getAttribute('data-src');
    if (!src) return;
    v.src = src;
    v.dataset.cpLoaded = '1';
    v.load();
  }

  /* ---- review modal ---- */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest('[data-cp-review]') : null;
    if (trigger) {
      event.preventDefault();
      var dialog = document.getElementById(trigger.getAttribute('data-modal'));
      if (!dialog) return;
      var source = trigger.parentNode.querySelector('[data-cp-review-full]');
      var target = dialog.querySelector('[data-cp-review-target]');
      if (source && target) {
        target.innerHTML = source.innerHTML;
        var rat = target.querySelector('.cp-rev__modal-rating');
        if (rat) {
          var n = parseInt(rat.getAttribute('data-rating') || '5', 10);
          rat.innerHTML = new Array(n + 1).join(STAR);
        }
      }
      dialog.__cpReturnFocus = trigger;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      return;
    }

    var closer = event.target.closest ? event.target.closest('[data-cp-review-close]') : null;
    if (closer) {
      event.preventDefault();
      var d2 = closer.closest('dialog');
      if (d2 && d2.open) d2.close();
    }
  });

  /* ---- hero carousel: text stays put, media changes ----
     Slide 1 ships with the page. Later slides only fetch video when first shown,
     so the initial payload matches the old single video hero. ---- */
  function initHero() {
    var hero = document.querySelector('[data-cp-hero]');
    if (!hero) return;
    var slides = [].slice.call(hero.querySelectorAll('[data-cp-slide]'));
    var dots = [].slice.call(hero.querySelectorAll('[data-cp-hero-dot]'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idx = 0, timer = null;
    if (slides.length < 2) { primeSlide(slides[0]); return; }
    var wait = parseInt(hero.getAttribute('data-interval') || '7000', 10);

    function primeSlide(el) {
      if (!el || reduce) return;
      var v = el.querySelector('video');
      if (!v) return;
      if (!v.dataset.cpLoaded) {
        var wide = window.matchMedia('(min-width: 900px)').matches;
        v.src = wide ? v.dataset.srcDesktop : v.dataset.srcMobile;
        v.dataset.cpLoaded = '1';
        v.load();
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    function show(n) {
      n = (n + slides.length) % slides.length;
      if (n === idx) return;
      slides[idx].classList.remove('is-active');
      slides[idx].setAttribute('aria-hidden', 'true');
      var old = slides[idx].querySelector('video');
      if (old && !old.paused) old.pause();
      idx = n;
      slides[idx].classList.add('is-active');
      slides[idx].removeAttribute('aria-hidden');
      primeSlide(slides[idx]);
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    }

    function start() { if (!reduce) { stop(); timer = setInterval(function () { show(idx + 1); }, wait); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function jump(n) { show(n); start(); }

    var prev = hero.querySelector('[data-cp-hero-prev]');
    var next = hero.querySelector('[data-cp-hero-next]');
    if (prev) prev.addEventListener('click', function () { jump(idx - 1); });
    if (next) next.addEventListener('click', function () { jump(idx + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { jump(i); }); });

    /* swipe */
    var x0 = null, y0 = null;
    hero.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) jump(idx + (dx < 0 ? 1 : -1));
      x0 = null; y0 = null;
    }, { passive: true });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    primeSlide(slides[0]);
    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHero);
  } else {
    initHero();
  }

  /* ---- product gallery: snap scroll, arrows and dots ---- */
  function initGallery() {
    var wraps = document.querySelectorAll('[data-cp-gallery]');
    for (var i = 0; i < wraps.length; i++) {
      (function (wrap) {
        var track = wrap.querySelector('[data-cp-track]') || wrap.querySelector('.cp-prodgal__track');
        if (!track) return;
        var prev = wrap.querySelector('[data-cp-gal-prev]');
        var next = wrap.querySelector('[data-cp-gal-next]');
        var dots = [].slice.call(wrap.querySelectorAll('[data-cp-gal-dot]'));

        /* one card, not one viewport, so tracks showing 2 or 3 at a time
           advance by a single card */
        function step() {
          var first = track.firstElementChild;
          if (!first) return track.clientWidth;
          var cs = window.getComputedStyle(track);
          var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
          return Math.max(1, first.getBoundingClientRect().width + gap);
        }
        function sync() {
          var s = step();
          var maxScroll = track.scrollWidth - track.clientWidth;
          var n = Math.round(track.scrollLeft / s);
          var last = Math.round(maxScroll / s);
          dots.forEach(function (d, k) {
            /* hide dots past the final resting position, otherwise the tail
               dots are unreachable when more than one card is in view */
            d.hidden = k > last;
            d.classList.toggle('is-active', k === Math.min(n, last));
          });
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
        }
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
        dots.forEach(function (d, k) {
          d.addEventListener('click', function () { track.scrollTo({ left: k * step(), behavior: 'smooth' }); });
        });
        track.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        sync();
      })(wraps[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }

  /* exploded parts markers are Minimog's own <m-hotspot>, driven by
     hotspots-image.js, so there is nothing to handle here. */

  /* ---- purpose collage: same dialog plumbing, no content swap needed ---- */
  document.addEventListener('click', function (event) {
    var t = event.target.closest ? event.target.closest('[data-cp-collage]') : null;
    if (!t) return;
    event.preventDefault();
    var d = document.getElementById(t.getAttribute('data-modal'));
    if (!d) return;
    d.__cpReturnFocus = t;
    if (typeof d.showModal === 'function') d.showModal();
    else d.setAttribute('open', '');
  });

  /* ---- carousel arrows: scroll by one card ---- */
  function initCarousels() {
    var wraps = document.querySelectorAll('[data-cp-carousel]');
    for (var i = 0; i < wraps.length; i++) {
      (function (wrap) {
        var track = wrap.querySelector('.cp-revs__track');
        var prev = wrap.querySelector('[data-cp-prev]');
        var next = wrap.querySelector('[data-cp-next]');
        if (!track) return;

        function step() {
          var card = track.firstElementChild;
          if (!card) return track.clientWidth;
          var gap = parseFloat(getComputedStyle(track).columnGap || '16') || 16;
          return card.getBoundingClientRect().width + gap;
        }
        function sync() {
          if (!prev || !next) return;
          var max = track.scrollWidth - track.clientWidth - 2;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= max;
        }
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
        track.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        sync();
      })(wraps[i]);
    }
  }

  /* ---- How it works lead video (Brief 6, 17 Sep 2026; split by breakpoint in Brief 7) ----
     Markup carries autoplay muted loop playsinline controls and no src or poster. When the
     video is within 400px of the viewport the script picks the poster and the ONE source for
     the current screen, using the theme's breakpoint (768px, as Minimog's own scripts):
       under 768  data-src-m (mobile video, 480p)
       768-1279   data-src-d (desktop video, 720p)
       1280 up    data-src-d-wide (desktop video, 1080p)
     The other rendition is never requested. If the screen crosses 768px later, an already
     loaded video swaps to the other file then (a rare resize, allowed). A failed derived URL
     falls back to the rendition Liquid listed. Plays in view, pauses out of view, respects a
     viewer's own pause. Reduced motion: never autoplays, controls still work. No tracking. */
  function initLeadVideo() {
    var vids = document.querySelectorAll('video[data-cp-lead]');
    if (!vids.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var desk = window.matchMedia('(min-width: 768px)');

    function pick(v) {
      var d = desk.matches;
      var src = d ? ((window.innerWidth >= 1280 && v.getAttribute('data-src-d-wide')) || v.getAttribute('data-src-d'))
                  : v.getAttribute('data-src-m');
      return {
        mode: d ? 'd' : 'm',
        src: src || (d ? v.getAttribute('data-src') : (v.getAttribute('data-src-small') || v.getAttribute('data-src'))),
        fallback: v.getAttribute(d ? 'data-src-d-fallback' : 'data-src-m-fallback'),
        poster: v.getAttribute(d ? 'data-poster-d' : 'data-poster-m')
      };
    }

    function load(v) {
      var p = pick(v);
      if (!p.src || v.dataset.cpMode === p.mode) return;
      var wasPlaying = v.dataset.cpMode && !v.paused;
      if (reduce) v.removeAttribute('autoplay');
      if (p.poster) v.setAttribute('poster', p.poster);
      v.dataset.cpMode = p.mode;
      v.dataset.cpFallback = p.fallback && p.fallback !== p.src ? p.fallback : '';
      v.src = p.src;
      v.load();
      if (wasPlaying && !reduce) {
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
      }
    }

    for (var i = 0; i < vids.length; i++) {
      (function (v) {
        v.addEventListener('pause', function () { if (!v.__cpAuto) v.dataset.cpUserPaused = '1'; v.__cpAuto = false; });
        v.addEventListener('play', function () { delete v.dataset.cpUserPaused; });
        v.addEventListener('error', function () {
          var fb = v.dataset.cpFallback;
          if (fb) { v.dataset.cpFallback = ''; v.src = fb; v.load(); }
        });
      })(vids[i]);
    }

    var onChange = function () {
      for (var k = 0; k < vids.length; k++) { if (vids[k].dataset.cpMode) load(vids[k]); }
    };
    if (desk.addEventListener) desk.addEventListener('change', onChange);
    else if (desk.addListener) desk.addListener(onChange);

    if (!('IntersectionObserver' in window)) {
      for (var j = 0; j < vids.length; j++) { load(vids[j]); }
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          load(v);
          if (!reduce && v.paused && !v.dataset.cpUserPaused) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          }
        } else if (!v.paused) {
          v.__cpAuto = true;
          v.pause();
        }
      });
    }, { rootMargin: '400px 0px', threshold: 0.01 });

    for (var n = 0; n < vids.length; n++) { io.observe(vids[n]); }
  }

  function initReviews() { initInViewVideo(); initCarousels(); initLeadVideo(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviews);
  } else {
    initReviews();
  }

  /* Esc closes via the native close event: tidy up and restore focus */
  document.addEventListener('close', function (event) {
    var dialog = event.target;
    if (!dialog || !dialog.classList || !dialog.classList.contains('cp-modal')) return;
    var video = dialog.querySelector('video');
    if (video) {
      video.pause();
      video.removeAttribute('src');
      while (video.firstChild) video.removeChild(video.firstChild);
    }
    if (dialog.__cpReturnFocus && dialog.__cpReturnFocus.focus) {
      dialog.__cpReturnFocus.focus();
      dialog.__cpReturnFocus = null;
    }
  }, true);
})();
